module.exports = __webpack_public_path__ + "img/no_pasting.4a55c0b7.svg";